import React from 'react';
import bannerImage from '../img/banner-frames.png';

// Notice shown on the old order app pointing customers to the new website.
// A plain link is intentional: visitors with a live sweetpixtiles.com session
// pass straight through, everyone else lands on the new site's login. The old
// app cannot read the new domain's cookies, so no token hand-off is possible here.
// This banner is always shown — there is no dismiss.
const NEW_SITE_URL = 'https://www.sweetpixtiles.com/';

export default function NewUiBanner() {
  return (
    <div className="new-ui-banner" role="region" aria-label="New website announcement">
      <div className="new-ui-banner__lead">
        <div
          className="new-ui-banner__image"
          style={{ backgroundImage: `url(${bannerImage})` }}
          aria-hidden="true"
        />
        <div className="new-ui-banner__copy">
          <p className="new-ui-banner__eyebrow">
            New platform <span aria-hidden="true">🎉</span>
          </p>
          <p className="new-ui-banner__title">New Sweet Pix site is ready.</p>
          <p className="new-ui-banner__sub">Easier uploads. Smarter tools.</p>
          <p className="new-ui-banner__promo">Get 20% off when you switch to the new site.</p>
        </div>
      </div>
      <div className="new-ui-banner__actions">
        <a
          className="new-ui-banner__cta"
          href={NEW_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit new site
        </a>
      </div>
    </div>
  );
}
